"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOilBlendingThemeBody = defaultOilBlendingThemeBody;
/**
 * Seed body created on first read for a tenant who has no theme record yet.
 * Mirrors the 6 hardcoded moods that the storefront currently ships, so
 * existing kiosks see the same content the moment the operator first opens
 * the editor.
 *
 * Each mood gets a generated id; the operator can rename/recolor/replace
 * but the id stays stable so already-recorded customer selections still
 * resolve.
 */
function defaultOilBlendingThemeBody() {
    return {
        version: 0,
        cardAspect: '4:5',
        cardCornerRadius: 24,
        pageBackground: { type: 'solid', color: '#FAF8F5' },
        banner: {
            enabled: true,
            mode: 'static',
            rotationSeconds: 6,
            heightPercent: 30,
            slides: [
                {
                    id: 'slide_default',
                    background: {
                        type: 'gradient',
                        angle: 135,
                        stops: [
                            { color: '#14532D', position: 0 },
                            { color: '#16A34A', position: 100 },
                        ],
                    },
                    text: {
                        title: 'Crafted just for you',
                        subtitle: "Pick your mood — we'll mix it at the counter",
                        font: 'Playfair Display',
                        color: '#FFFFFF',
                        titleSize: 56,
                        subtitleSize: 18,
                        weight: 700,
                        align: 'left',
                        valign: 'center',
                    },
                },
            ],
        },
        moods: [
            {
                id: 'mood_calming',
                order: 0,
                enabled: true,
                background: {
                    type: 'gradient',
                    angle: 160,
                    stops: [
                        { color: '#A7F3D0', position: 0 },
                        { color: '#34D399', position: 100 },
                    ],
                },
                foreground: { enabled: false, scale: 40 },
                text: {
                    title: 'Calming',
                    subtitle: 'Lavender · Chamomile · Sandalwood',
                    font: 'Cormorant Garamond',
                    color: '#FFFFFF',
                    titleSize: 42,
                    subtitleSize: 14,
                    weight: 600,
                    align: 'left',
                    valign: 'bottom',
                },
                fragranceIds: [],
            },
            {
                id: 'mood_energizing',
                order: 1,
                enabled: true,
                background: {
                    type: 'gradient',
                    angle: 135,
                    stops: [
                        { color: '#FEF3C7', position: 0 },
                        { color: '#F59E0B', position: 100 },
                    ],
                },
                foreground: { enabled: false, scale: 40 },
                text: {
                    title: 'Energizing',
                    subtitle: 'Citrus · Peppermint · Eucalyptus',
                    font: 'DM Serif Display',
                    color: '#422006',
                    titleSize: 42,
                    subtitleSize: 14,
                    weight: 400,
                    align: 'left',
                    valign: 'bottom',
                },
                fragranceIds: [],
            },
            {
                id: 'mood_romantic',
                order: 2,
                enabled: true,
                background: {
                    type: 'gradient',
                    angle: 135,
                    stops: [
                        { color: '#FBCFE8', position: 0 },
                        { color: '#BE185D', position: 100 },
                    ],
                },
                foreground: { enabled: false, scale: 40 },
                text: {
                    title: 'Romantic',
                    subtitle: 'Rose · Jasmine · Ylang Ylang',
                    font: 'Playfair Display',
                    color: '#FFFFFF',
                    titleSize: 42,
                    subtitleSize: 14,
                    weight: 700,
                    align: 'left',
                    valign: 'bottom',
                },
                fragranceIds: [],
            },
            {
                id: 'mood_focused',
                order: 3,
                enabled: true,
                background: { type: 'solid', color: '#1C1917' },
                foreground: { enabled: false, scale: 40 },
                text: {
                    title: 'Focused',
                    subtitle: 'Rosemary · Basil · Lemon',
                    font: 'Manrope',
                    color: '#FED7AA',
                    titleSize: 40,
                    subtitleSize: 14,
                    weight: 700,
                    align: 'left',
                    valign: 'bottom',
                },
                fragranceIds: [],
            },
            {
                id: 'mood_grounding',
                order: 4,
                enabled: true,
                background: {
                    type: 'gradient',
                    angle: 135,
                    stops: [
                        { color: '#78716C', position: 0 },
                        { color: '#292524', position: 100 },
                    ],
                },
                foreground: { enabled: false, scale: 40 },
                text: {
                    title: 'Grounding',
                    subtitle: 'Cedar · Vetiver · Patchouli',
                    font: 'Lora',
                    color: '#FAFAF9',
                    titleSize: 42,
                    subtitleSize: 14,
                    weight: 600,
                    align: 'left',
                    valign: 'bottom',
                },
                fragranceIds: [],
            },
            {
                id: 'mood_refreshing',
                order: 5,
                enabled: true,
                background: {
                    type: 'gradient',
                    angle: 160,
                    stops: [
                        { color: '#CFFAFE', position: 0 },
                        { color: '#0891B2', position: 100 },
                    ],
                },
                foreground: { enabled: false, scale: 40 },
                text: {
                    title: 'Refreshing',
                    subtitle: 'Mint · Cucumber · Bergamot',
                    font: 'Playfair Display',
                    color: '#FFFFFF',
                    titleSize: 42,
                    subtitleSize: 14,
                    weight: 700,
                    align: 'left',
                    valign: 'bottom',
                },
                fragranceIds: [],
            },
        ],
    };
}
//# sourceMappingURL=defaults.js.map